import groq from 'groq'

export const campaignContentGroq = groq`
  coalesce(
    *[_type == "campaignContent" && path == $path][0] {
      title,
      subtitle,
      clickText,
    },
    {}
  )
`
